import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import classNames from "classnames";
// --- Import redux
import { connect } from "react-redux";
import {
  setAuthStatus,
  setUserLoggedOut,
} from "../../../store/actionCreators/userDataActionCreator";
import {
  setInitialized,
  setCookieExisted,
} from "../../../store/actionCreators/appActionCreator";
import eraseCookie from "../../../hooks/eraseCookie";
// --- Import images
import ArrowDown from "../../../assets/images/arrow_down.png";
import AccountIcon from "../../../assets/images/account_icon.png";
import LogoutIcon from "../../../assets/images/icon_logout.png";

import selectStyles from "../../UI/Select/Select.module.sass";

import "./ProfileSelect.sass";

function renderOptionsList() {
  const defaultOptionsList = [
    { title: "My Apps", link: "/myApps" },
    { title: "My Profile", link: "/profile" },
    { title: "My subscriptions", link: "/subscriptions" },
    { title: "Transaction History", link: "/transaction" },
    { title: "Change Password", link: "/changePassword" },
  ];
  return defaultOptionsList;
}

function ProfileSelect({
  userData,
  setIsAuth,
  setLoggedOut,
  setInitialize,
  setCookie,
}) {
  const component = useRef();
  const history = useHistory();
  const [showOptionsList, setShowOptionsList] = useState(false);

  function handleLogout() {
    eraseCookie("aAuth");
    setIsAuth(false);
    setLoggedOut();
    setInitialize(false);
    setCookie(false);
    history.push("/");
  }

  // --- Function to close options list
  const handleClickOutside = (e) => {
    if (component.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setShowOptionsList(false);
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // --- Function to open options list
  const handleListDisplay = () => {
    setShowOptionsList(!showOptionsList);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <article
      ref={component}
      className={classNames(selectStyles.select, "profile-select")}
    >
      <section
        role="button"
        tabIndex={0}
        onClick={handleListDisplay}
        onKeyUp={handleListDisplay}
      >
        <img src={AccountIcon} alt="" className="profile-select__icon" />
        <button
          className={classNames(
            selectStyles.select__text,
            "profile-select__button"
          )}
        >
          {userData !== null && userData.first_name}
          <img src={ArrowDown} alt="" />
        </button>
      </section>
      <CSSTransition
        in={showOptionsList}
        timeout={300}
        classNames="list-transition"
        unmountOnExit
      >
        <ul
          className={classNames(
            selectStyles.select__optionsList,
            "profile-select__options-list"
          )}
        >
          {renderOptionsList().map((option, i) => {
            return (
              <li
                key={i}
                className={classNames(
                  selectStyles.select__option,
                  "profile-select__option"
                )}
              >
                <Link
                  to={option.link}
                  className={classNames(selectStyles.select__optionLink)}
                  onClick={handleListDisplay}
                >
                  {option.title}
                </Link>
              </li>
            );
          })}
          <li
            className={classNames(
              selectStyles.select__option,
              "profile-select__option"
            )}
          >
            <div
              tabIndex={0}
              role="button"
              onClick={handleLogout}
              onKeyUp={handleLogout}
              className="profile-select__option-logout"
            >
              <span>Logout</span>
              <img src={LogoutIcon} alt="" />
            </div>
          </li>
        </ul>
      </CSSTransition>
    </article>
  );
}

ProfileSelect.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
  setIsAuth: PropTypes.func.isRequired,
  setLoggedOut: PropTypes.func.isRequired,
  setInitialize: PropTypes.func.isRequired,
  setCookie: PropTypes.func.isRequired,
};
ProfileSelect.defaultProps = {
  userData: null,
};

const mapStateToProps = (state) => {
  return {
    userData: state.userDataStore.userData,
    isAuth: state.userDataStore.isAuth,
  };
};
const mapDispatchToProps = {
  setIsAuth: setAuthStatus,
  setLoggedOut: setUserLoggedOut,
  setInitialize: setInitialized,
  setCookie: setCookieExisted,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSelect);
